/* @flow */
import * as React from 'react';
import { connect } from 'react-redux';
import { orgTypeString as ORG_TYPE_STRING } from 'constants/SelfServeConstants';
import Text from 'components/Text';
import type { Fields } from 'admin/reducers/adminUpgradePage';

function AdminUpgradeTitle(props: {
  pageIndex: number,
  text?: string,
  subtext?: any,
  fields: Fields,
  paymentMethod?: string,
  quoteStudentCount?: number,
}) {
  const { pageIndex, paymentMethod, subtext, text } = props;

  const TITLES: Array<{ text: string, subtext?: string }> = [
    {
      text: 'Tell us about your organization',
      subtext: 'We’ll use this information to calculate a quote.',
    },
    {
      text: `Your Remind plan quote`,
      subtext: 'You’ll be able to review your order before completing your purchase.',
    },
    {
      text: 'Review your Remind plan',
      subtext:
        paymentMethod === 'card'
          ? 'Enter your payment details to complete your purchase.'
          : 'You’ll receive an invoice and instructions for paying by check or wire transfer.',
    },
  ];

  const title = TITLES[pageIndex];

  if (!title && !text) {
    console.error(
      `AdminUpgradeTitle - could not find title for page = ${pageIndex}, expected 0 <= page <= ${TITLES.length}`
    );
    return null;
  }

  return (
    <div style={{ minHeight: 49 /* to keep same height when subtext is empty */ }}>
      <Text weight="semibold" size="xlarge" element="div">
        {text || title.text}
      </Text>
      <Text size="medium" element="div">
        {subtext || title.subtext}
      </Text>
    </div>
  );
}

function mapStateToProps(state) {
  return {
    pageIndex: state.adminUpgradePage.pageIndex,
    fields: state.adminUpgradePage.fields,
    orgTypeString: ORG_TYPE_STRING[state.adminUpgradePage.fields.get('orgType')],
    paymentMethod: state.adminUpgradePage.paymentMethod,
  };
}

export { AdminUpgradeTitle };
// $FlowFixMe
export default connect(mapStateToProps)(AdminUpgradeTitle);
